import { ChangeDetectionStrategy, Component, HostListener, input, output, signal } from "@angular/core";
import { LoaderSpinnerAyModule } from "features";
import { SafeResourceUrl } from "@angular/platform-browser";
import { AlertModule, IconModule } from "@jack-sparrow-libraries/ui-kit";
import { environment } from "@env/environment";

@Component({
	selector: "cba-cotix-popup",
	imports: [LoaderSpinnerAyModule, IconModule, AlertModule],
	templateUrl: "./cotix-popup.component.html",
	styles: `
		iframe {
			width: 100%;
			height: 100%;
		}
	`,
	host: {
		class: "w-full h-full flex flex-col",
	},
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CotixPopupComponent {
	readonly $cotixUrl = input.required<SafeResourceUrl>({ alias: "cotixUrl" });
	readonly closePopup = output<void>();

	readonly $iframeLoaded = signal(false);

	protected close() {
		this.closePopup.emit();
	}

	protected loaded() {
		this.$iframeLoaded.set(true);
	}

	@HostListener("window:message", ["$event"])
	onMessage(event: MessageEvent) {
		if (event.origin !== environment.cotixUrl) return;
		if (event.data.type === "cotationFinale") {
			console.log("Event Cotix", event.data);
		}
	}
}
